import React, {useEffect, useRef, useState} from 'react';
import {
    ActivityIndicator,
    CCText,
    FlatList,
    Modal,
    View
} from "../../../custom-packages/react-native-components-in-react/react-native-components-in-react";
import Styles from "../../../Styles";
import {DarkButton} from "../../../custom-packages/react-button-package/ButtonPackage";
import TTableQrCodeModal from "./Translations/TTableQrCodeModal";
import AppConfig from "../../../AppConfig";
import {useSelector} from "react-redux";
import {QRCodeSVG} from "qrcode.react";
import JSZip from "jszip";

import domtoimage from 'dom-to-image';
import QRCodeWrapper from "../../../custom-packages/QRCodeWrapper/QRCodeWrapper";

const TableQrCodeModal = ({ section, visible, onRequestClose }) => {
    const auth = useSelector(state => state.Auth);

    const qrCodeRefs = useRef([]);
    const capturedQrCodes = useRef([]);

    const [loading, setLoading] = useState(true);
    const [processing, setProcessing] = useState(true);
    const [compressing, setCompressing] = useState(false);
    const [successDownload, setSuccessDownload] = useState(false);
    const [tables, setTables] = useState([]);
    const [menu, setMenu] = useState({});

    useEffect(() => {
        if(!visible)
            return

        const fetchData = async () => {
            try {
                const response = await fetch(AppConfig.URL + "/Restaurant/FetchMenu/" + section.rsE_RESTAURANT_ID, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': auth.token
                    }
                });

                const json = await response.json();

                const logoResponse = await fetch(AppConfig.URL + "/Menu/FetchMenuLogo/" + json.menu.meN_ID, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': auth.token
                    }
                });

                const logoJson = await logoResponse.json();

                json.menu.meN_LOGO = logoJson.image;

                setMenu(json.menu)
            } catch (e) {

            }

            setTables([])
        }

        fetchData()
    }, [visible]);

    useEffect(() => {
        if(!visible)
            return

        setProcessing(tables.length != section.tablesForEditor.length)

        if(tables.length != section.tablesForEditor.length)
            slowRollQrCode(section.tablesForEditor);
    }, [tables]);

    const renderItem = ({ item }) => {
        return (
            <View style={{...Styles.horizontalPadding, ...Styles.borderCard}}>
                <div
                    ref={(ref) => {
                        if(!ref)
                            return;

                        const index = qrCodeRefs.current.findIndex(i => i === ref);

                        if(index > -1)
                            return;

                        qrCodeRefs.current.push(ref);
                    }}
                    style={{
                        padding: 20,
                    }}
                >
                    <View style={{justifyContent: 'center', ...Styles.flexDirectionRow}}>
                        <QRCodeWrapper
                            url={AppConfig.DOMAIN + '/PublicActions/TableProxy/' + item.rtA_ID}
                            logo={menu.meN_LOGO}
                            showDownloadButton={false}
                        />
                    </View>
                    <View style={{ marginTop: 10, justifyContent: 'center', ...Styles.flexDirectionRow}}>
                        <CCText style={{fontSize: 20, fontStyle: 'italic', color: '#444444'}}>
                            {section.rsE_NAME}
                        </CCText>
                    </View>
                    <View style={{justifyContent: 'center', ...Styles.flexDirectionRow}}>
                        <CCText style={{fontWeight: 'bold', fontSize: 26}}>
                            {TTableQrCodeModal[AppConfig.lang].TABLE + ' ' + item.rtA_TABLE_NUMBER}
                        </CCText>
                    </View>
                </div>
            </View>
        );
    };

    const renderHeader = () => {
        if (processing) {
            return (
                <View style={{flexDirection: 'row', justifyContent: 'center'}}>
                    <View>
                        <ActivityIndicator size={40} color={Styles.themeColor.color} style={{marginBottom: 7}}/>
                        <CCText style={{textAlign: 'center'}}>
                            {TTableQrCodeModal[AppConfig.lang].GENERATING_QR_CODES}
                        </CCText>
                    </View>
                </View>
            );
        }

        if (compressing) {
            return (
                <View style={{flexDirection: 'row', justifyContent: 'center'}}>
                    <View>
                        <ActivityIndicator size={40} color={Styles.themeColor.color} style={{marginBottom: 7}}/>
                        <CCText style={{textAlign: 'center'}}>
                            {TTableQrCodeModal[AppConfig.lang].COMPRESSING}
                        </CCText>
                    </View>
                </View>
            );
        }

        return (
            <View>
                <View style={{justifyContent: 'space-evenly', ...Styles.flexDirectionRow}}>
                    {successDownload ?
                        <div className={'alert alert-success'} style={{ marginBottom: 10 }}>
                            <CCText style={{ fontSize: 17, textAlign: 'center' }}>
                                {TTableQrCodeModal[AppConfig.lang].DOWNLOADING}
                            </CCText>
                        </div>
                    :
                        null
                    }
                </View>
                <View style={{justifyContent: 'space-evenly', ...Styles.flexDirectionRow}}>
                    <DarkButton
                        text={TTableQrCodeModal[AppConfig.lang].DOWNLOAD_ALL}
                        onPress={downloadQRCodes}
                        textStyle={{fontSize: 16}}
                    />
                </View>
            </View>
        );
    };

    const slowRollQrCode = (propsTables) => {
        const firstNotAddedEntry = propsTables.find(
            (entry) => !tables.some((table) => table.rtA_ID === entry.rtA_ID)
        );

        if(firstNotAddedEntry) {
            setTimeout(() => {
                const newTables = [...tables];
                //const index = propsTables.findIndex(i => i.rtA_ID == )

                newTables.push(firstNotAddedEntry)

                setTables(newTables);
            }, 125);
        }
    };

    const downloadQRCodes = async () => {
        setCompressing(true);

        setTimeout(async () => {
            const zip = new JSZip();

            const validQrCodeRefs = qrCodeRefs.current.filter((qrCodeRef) => qrCodeRef !== null);

            capturedQrCodes.current = [];

            for (const [i, qrCodeRef] of validQrCodeRefs.entries()) {
                try {
                    const dataUrl = await domtoimage.toPng(qrCodeRef, {
                        backgroundColor: 'transparent',
                    });
                    capturedQrCodes.current.push(dataUrl);

                    const base64Data = dataUrl.split(',')[1];
                    const mimeType = dataUrl.split(';')[0].split(':')[1];
                    const extension = mimeType.split('/')[1];

                    zip.file(`file${i + 1}.${extension}`, base64Data, { base64: true });
                } catch (err) {
                    console.error(`Error capturing QR code ${i + 1}:`, err);
                }
            }

            try {
                const content = await zip.generateAsync({ type: 'blob' });
                const url = URL.createObjectURL(content);

                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = section.rsE_NAME;
                anchor.click();

                URL.revokeObjectURL(url);

                setSuccessDownload(true)
            } catch (err) {
                console.error('Error generating the zip file:', err);
            }

            setCompressing(false);
        }, 50)
    };

    return <Modal
        visible={visible}
        onRequestClose={onRequestClose}
    >
        <FlatList
            keyboardShouldPersistTaps={'always'}
            maxToRenderPerBatch={200}
            windowSize={200}
            style={{height: '100%', padding: 15, paddingTop: 0}}
            keyExtractor={item => {
                return item.rtA_ID;
            }}
            data={tables}
            renderItem={renderItem}
            ListHeaderComponent={renderHeader}
            ListFooterComponent={() => {
                let Component = null;

                if (loading) {

                } else {
                    Component = <View style={{height: 40}}></View>;
                }

                return Component;
            }}
        />
    </Modal>;
}

export default TableQrCodeModal;